import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons';
import { Item } from '@calendly/ui/components/menu';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { ViewportDropdownMenu } from 'components/core/viewport_dropdown_menu';
const ROLES = ['editor', 'viewer'];
const dividerCss = "d1dwsfju";
const Divider = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'hr';
  return <Component ref={ref} {...restProps} aria-hidden className={classNames(dividerCss, props.className)} />;
});

// 171px is the max width of this component across currently available languages
const containerCss = "chc19kh";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const itemWrapperCss = "iytjsj";
const ItemWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(itemWrapperCss, props.className)} />;
});
const getTitle = value => ({
  editor: I18n.t('publisher.event_types.edit_hosts_modal.permissions.editor'),
  viewer: I18n.t('publisher.event_types.edit_hosts_modal.permissions.viewer')
})[value];
const getDescription = value => ({
  editor: I18n.t('publisher.event_types.edit_hosts_modal.permissions.editor_description'),
  viewer: I18n.t('publisher.event_types.edit_hosts_modal.permissions.viewer_description')
})[value];
const ItemText = ({
  role,
  isSelected = false
}) => <ItemWrapper>
    <BodyText weight={isSelected ? 'bold' : 'standard'}>{getTitle(role)}</BodyText>
    <BodyText color="muted" size="medium">{getDescription(role)}</BodyText>
  </ItemWrapper>;
export const RoleSelect = ({
  value,
  onChange,
  onRemove,
  onTransfer
}) => {
  const [toggleDropdown, Dropdown, isDropdownOpen] = useDropdown();
  return <Container>
      <Button decoration="ghost" onClick={toggleDropdown} aria-label={I18n.t('publisher.event_types.edit_hosts_modal.permissions_selector_label')} aria-expanded={isDropdownOpen}>
        <FullStoryMask>{getTitle(value)}</FullStoryMask>
        {isDropdownOpen ? <ArrowChevronUpMiniIcon /> : <ArrowChevronDownMiniIcon />}
      </Button>
      <Dropdown>
        <ViewportDropdownMenu data-testid="permissions-selector-menu">
          {ROLES.map(role => <Item key={role} onClick={() => onChange(role)}>
              <ItemText role={role} isSelected={role === value} />
            </Item>)}
          {(onRemove || onTransfer) && <Divider />}
          {onRemove && <Item onClick={() => onRemove()}>
              <BodyText>{I18n.t('publisher.event_types.edit_hosts_modal.delete_permission')}</BodyText>
            </Item>}
          {onTransfer && <Item onClick={() => onTransfer()}>
              <BodyText>{I18n.t('publisher.event_types.edit_hosts_modal.transfer')}</BodyText>
            </Item>}
        </ViewportDropdownMenu>
      </Dropdown>
    </Container>;
};

require("./role_select.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./role_select.js");